import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

export const EmptyStateWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    text-align: center;
    padding: 10px;
`

export const Heading = styled(Typography)<{ theme?: TTheme }>`
    margin-top: 20px;
    color: ${({ theme }) => theme?.colors.greys[800]};
`

export const Description = styled(Typography)<{ theme?: TTheme }>`
    margin: 0 0 6px 0;
    max-width: 640px;
    color: ${({ theme }) => theme?.colors.greys[600]};
    text-align: center;
    padding: 0 100px;
`
